import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import OperationsSchedulePanel from "./OperationsSchedulePanel";
import ParkedByLotModal from "./ParkedByLotModal";
import ParkedByLotPanel from "./ParkedByLotPanel";
import PickupCapacityPanel from "./PickupCapacityPanel";
import useParkedByLot from "../useParkedByLot";
import usePickupCapacitySettings from "../usePickupCapacitySettings";
import useBlackoutPeriods from "../../blackouts/useBlackoutPeriods";
import useValetCapacityForecast from "../useValetCapacityForecast";
import useVenueDayRollover from "../useVenueDayRollover";
import { today as venueToday } from "../forecastRange";

const useStyles = makeStyles({
  lower: {
    display: "grid",
    gridTemplateColumns:
      "minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr)",
    gap: 20,
    alignItems: "start",
    marginTop: 20,
    "@media (max-width: 1100px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
});

export default function OperationsPreviewBlocks({
  installation,
  sessions = [],
  onOpenCar,
}) {
  const s = useStyles();
  const [selectedLotId, setSelectedLotId] = useState(null);
  const now = Date.now();
  const installationId = installation?.id;
  const { lots, loading, error } = useParkedByLot(installationId);
  const {
    shifts,
    loading: settingsLoading,
    error: settingsError,
  } = usePickupCapacitySettings(installationId);
  const {
    periods: blackouts,
    loading: blackoutsLoading,
    error: blackoutsError,
  } = useBlackoutPeriods(installationId, false);
  const timezone = installation?.timeZoneName;
  const [capacityMonth, setCapacityMonth] = useState(() =>
    venueToday(timezone).slice(0, 7),
  );

  useEffect(() => {
    setCapacityMonth(venueToday(timezone).slice(0, 7));
  }, [timezone]);

  useVenueDayRollover(timezone, (currentDay) => {
    setCapacityMonth(currentDay.slice(0, 7));
  });
  const {
    forecast: capacityForecast,
    loading: capacityLoading,
    error: capacityError,
  } = useValetCapacityForecast(installationId, capacityMonth);
  const selectedLot = lots.find((lot) => lot.id === selectedLotId) ?? null;
  const selectedLotSessions = selectedLot
    ? sessions.filter((session) => session.lotId === selectedLot.id)
    : [];

  return (
    <>
      <div className={s.lower}>
        <OperationsSchedulePanel timezone={timezone} />
        <ParkedByLotPanel
          lots={lots}
          loading={loading}
          error={error}
          onOpenLot={(lot) => setSelectedLotId(lot.id)}
        />
        <PickupCapacityPanel
          now={now}
          shifts={shifts}
          blackouts={blackouts}
          forecast={capacityForecast}
          loading={capacityLoading}
          error={capacityError}
          settingsLoading={settingsLoading || blackoutsLoading}
          settingsError={settingsError || blackoutsError}
          timezone={timezone}
        />
      </div>

      {selectedLot && (
        <ParkedByLotModal
          lot={selectedLot}
          sessions={selectedLotSessions}
          now={now}
          onClose={() => setSelectedLotId(null)}
          onOpenCar={onOpenCar}
        />
      )}
    </>
  );
}
